import { UsersState, defaultUsersState, createUserForm } from "./state";
import { Action } from "redux";
import { getUsersRequest } from "@common";
import { changeCreateUserModalStatusAction } from "./actions";

export function usersReducer(state: UsersState = defaultUsersState, action: Action): UsersState {
    if (createUserForm.actions.isMyAction(action)) {
        return {
            ...state,
            createUserForm: createUserForm.reducer(state.createUserForm, action)
        };
    }

    if (getUsersRequest.actions.isMy(action)) {
        return {
            ...state,
            usersList: getUsersRequest.reducer(state.usersList, action)
        };
    }

    if (changeCreateUserModalStatusAction.is(action)) {
        return {
            ...state,
            createUserModalStatus: action.isOpen,
            createUserForm: action.isOpen ? state.createUserForm : createUserForm.state.empty()
        };
    }

    return state;
}
